<template>
  <div
    class="global-todos-table"
    data-testid="global-todos-table"
  >
    <AppScrollableTable :has-fixed-column="false">
      <AppTable
        ref="table"
        hoverable
        :loading="showLoading"
        :table-data="globalTodos"
      >
        <template #empty>
          <div
            class="mt-20 text-center"
            data-testid="global-todos-empty-state"
          >
            <img
              :src="IMAGE_EMPTY_BOX"
              class="mb-16"
              alt="Empty Box"
              data-testid="global-todos-empty-state-image"
            >
            <h4 class="">Add global to-dos</h4>
            <p class="text-muted">
              Create global to-dos and easily add<br />
              them to multiple projects
            </p>
          </div>
        </template>
        <AppTableColumn
          v-slot="{ row }"
          header="Name"
        >
          {{ row.name }}
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          header="Projects"
        >
          {{ row.projects_count }}
        </AppTableColumn>
        <AppTableColumn
          v-slot="{ row }"
          class="text-right"
          direction="right"
        >
          <div data-testid="global-todo-row-actions">
            <AppDropdown
              class="pull-right table-actions-dropdown"
              direction="right"
              label="Actions"
              track
              track-scope="Global todos table"
              size="small"
            >
              <AppDropdownItem
                data-test-id="edit-global-todo-action"
                @click="openEditDialog(row)"
              >
                Edit global to-do
              </AppDropdownItem>
              <AppDropdownItem
                data-test-id="delete-global-todo-action"
                @click="openDeleteDialog(row)"
              >
                Delete global to-do
              </AppDropdownItem>
            </AppDropdown>
          </div>
        </AppTableColumn>
      </AppTable>
    </AppScrollableTable>
  </div>
</template>

<script>
import { IMAGE_EMPTY_BOX } from '~/rails_assets';

export default {
  name: 'GlobalTodosTable',
  props: {
    globalTodos: {
      type: Array,
      required: true,
    },
    showLoading: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['open-edit-dialog', 'open-delete-dialog'],
  data() {
    return {
      IMAGE_EMPTY_BOX,
    };
  },
  methods: {
    openEditDialog(globalTodo) {
      this.$emit('open-edit-dialog', globalTodo);
    },
    openDeleteDialog(globalTodo) {
      this.$emit('open-delete-dialog', globalTodo);
    },
  },
};
</script>
